import navVertical from "./../../front/views/navigation";
import AccordionModule from "./../../front/views/modules/AccordionModule";
import AccordionModuleAnimation from "./../../front/views/modules/AccordionModule/animation";
import CircleImagesAnimation from "./../../front/views/modules/CircleImages/animation";
import CircleImagesHeadlinesAnimation from "./../../front/views/modules/CircleImagesHeadlines/animation";
import CircleImageModal from "./../../front/views/modules/CircleImageModal";
import CircleImageModalAnimation from "../../front/views/modules/CircleImageModal/animation";
import ContactImageAnimation from "./../../front/views/modules/ContactImage/animation";
import ContactModuleAnimation from "../../front/views/modules/Contact/animation";
import DoubleHeightModule from "./../../front/views/modules/DoubleHeightModule";
import GallerySlider from "./../../front/views/modules/GallerySlider";
import GalleryWall from "./../../front/views/modules/GalleryWall";
import HeroModuleAnimation from "./../../front/views/modules/HeroModule/animation";
import ImageAddressAnimation from "../../front/views/modules/ImageAddress/animation";
import LogoWall from "./../../front/views/modules/LogoWall";
import SpacerModuleAnimation from "./../../front/views/modules/SpacerModule/animation";
import TabIcon from "./../../front/views/modules/TabIcon";
import TabIconAnimation from "../../front/views/modules/TabIcon/animation";
import TableAnimation from "./../../front/views/modules/Table/animation";
import TeaserBig from "./../../front/views/modules/TeaserBig";
import TeaserSmallIconsAnimation from "./../../front/views/modules/TeaserSmallIcons/animation";
import TeaserSmallImages from "./../../front/views/modules/TeaserSmallImages";
import TeaserSmallImagesAnimation from "./../../front/views/modules/TeaserSmallImages/animation";
import TextModuleAnimation from "./../../front/views/modules/TextModule/animation";
import TextImageAnimation from "./../../front/views/modules/TextImage/animation";
import TwoColumnsImageAnimation from "../../front/views/modules/TwoColumnsImage/animation";
import UpperSectionAnimation from "../../front/views/modules/DoubleHeightModule/upperSectionAnimation";
import LowerSectionAnimation from "../../front/views/modules/DoubleHeightModule/lowerSectionAnimation";
const AppModulesLoader = () => {
  navVertical();
  AccordionModule();
  AccordionModuleAnimation();
  ContactImageAnimation();
  ContactModuleAnimation();
  CircleImagesAnimation();
  CircleImagesHeadlinesAnimation();
  CircleImageModal();
  CircleImageModalAnimation();
  DoubleHeightModule();
  GallerySlider();
  GalleryWall();
  HeroModuleAnimation();
  ImageAddressAnimation();
  LogoWall();
  SpacerModuleAnimation();
  TabIcon();
  TabIconAnimation();
  TableAnimation();
  TeaserBig();
  TeaserSmallIconsAnimation();
  TeaserSmallImages();
  TeaserSmallImagesAnimation();
  TextModuleAnimation();
  TextImageAnimation();
  TwoColumnsImageAnimation();
  UpperSectionAnimation();
  LowerSectionAnimation();
};
export default AppModulesLoader;
